import React, { useEffect } from "react";
import { transformToHtml } from "../../../utils/CommonUtils";
import FlightStatusTiming from "../FlightStatusTiming/FlightStatusTiming";
import OtpWeatherCard from "../OtpWeatherCard/OtpWeatherCard";
import AircraftSeatingAmenitiesCard from "../AircraftSeatingAmenitiesCard/AircraftSeatingAmenitiesCard";
import ShareCta from "../ShareCta/ShareCta";
import { FLIGHT_STATUS_CARD_TYPES } from "../constants";

/**
 * Flight Status Detail – UI only.
 * Renders title, share area, and cards (STATUS_CARD, OTP_WEATHER, AIRCRAFT_INFO).
 * cardsData, disclaimer, title, shareCta come from props (mock for now; API later).
 */
export default function FlightStatusDetail({
  cardsData,
  disclaimer,
  title,
  shareCta,
  logEvent = () => {},
  clearRefreshTimer = () => {},
  h1Header,
}) {
  useEffect(() => {
    window?.scrollTo?.({ top: 0 });
    return () => {
      clearRefreshTimer();
    };
  }, [clearRefreshTimer]);

  const renderCard = (type, card) => {
    if (!card) return null;
    switch (type) {
      case FLIGHT_STATUS_CARD_TYPES.STATUS_CARD:
        return (
          <FlightStatusTiming
            key={type}
            statusCardData={card.data}
            logEvent={logEvent}
          />
        );
      case FLIGHT_STATUS_CARD_TYPES.OTP_WEATHER:
        return (
          <OtpWeatherCard
            key={type}
            data={card.data}
            logEvent={logEvent}
          />
        );
      case FLIGHT_STATUS_CARD_TYPES.AIRCRAFT_INFO:
        return (
          <AircraftSeatingAmenitiesCard
            key={type}
            data={card.data}
            logEvent={logEvent}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="fsd-container">
      <div className="makeFlex spaceBetween">
        {h1Header ? (
          <h1 className="fontSize20 blackFont">
            <font color="#ffffff">{transformToHtml(h1Header)}</font>
          </h1>
        ) : title ? (
          <h1 className="fontSize20 blackFont">{transformToHtml(title)}</h1>
        ) : null}
        {shareCta && <ShareCta shareCta={shareCta} logEvent={logEvent} />}
      </div>

      {cardsData?.order?.map((type) => {
        const card = cardsData?.cards?.find((c) => c.type === type);
        return renderCard(type, card);
      })}

      {disclaimer && (
        <div className="fsd-disclaimer">
          <div className="fontSize14">{transformToHtml(disclaimer)}</div>
        </div>
      )}
    </div>
  );
}
